export default __webpack_public_path__ + "media/images/3-dogs-spaced-1be8d1883ec6b98cdb23e207a7c246dd.svg";